export default __webpack_public_path__ + "d919728e042d9c2cc5a6d13c10557126.jpg";